<template>
  <md-card>
    <md-card-media class="md-ratio-4-3" v-if="hasSlot('imageHeader') && checkBoolean(cardHeader)">
        <slot name="imageHeader"></slot>
    </md-card-media>

    <md-card-content>
      <slot name="title"></slot>
      <slot name="description"></slot>
    </md-card-content>
    <md-card-actions class="md-alignment-left">
      <div class="stats">
        <template v-if="hasSlot('date')">
          <md-icon>calendar_today</md-icon> <slot name="date"></slot>
        </template>
        <template v-if="hasSlot('time')">
          <md-icon>access_time</md-icon> <slot name="time"></slot>
        </template>
      </div>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "challenge-card",
  props: {
    headerAnimation: {
      type: String,
      default: "false"
    },
    cardHeader: {
      type: String,
      default: "true"
    }
  },
  data() {
    return {
      imgHovered: false,
      fixedHeader: false
    };
  },
  methods: {
    hasSlot(name) {
      return this.$slots[name];
    },
    checkBoolean: function(v) {
      return v.toString() === "true";
    },
    headerBack: function() {
      this.fixedHeader = false;
    },
    onMouseOver: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = true;
      }
    },
    onMouseLeave: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = false;
      }
    }
  }
};
</script>

<style lang="scss">
  .description,
  .md-card-media-cover {
    color: #000;
  }
  .description > p {
    margin: 0;
  }

</style>
